export const getInputRange = (
	mode: "hero" | "multibrowse" | "uncontained",
	carouselWidth: number,
	index: number,
) => {
	switch (mode) {
		case "hero":
			return [
				(index - 2) * carouselWidth + 8 * index,
				(index - 1) * carouselWidth + 8 * index,
				index * carouselWidth + 8 * index,
				(index + 1) * carouselWidth + 8 * index,
				(index + 2) * carouselWidth + 8 * index,
			];
		case "multibrowse":
			return [
				(index - 3) * carouselWidth + 8 * index,
				(index - 2) * carouselWidth + 8 * index,
				(index - 1) * carouselWidth + 8 * index,
				index * carouselWidth + 8 * index,
				(index + 1) * carouselWidth + 8 * index,
				(index + 2) * carouselWidth + 8 * index,
				(index + 3) * carouselWidth + 8 * index,
			];
		default:
			return [0, 0, 0, 0, 0];
	}
};
export const getOutputRange = (
	mode: "hero" | "multibrowse" | "uncontained",
	carouselWidth: number,
) => {
	switch (mode) {
		case "hero":
			return [0, 56, carouselWidth, 56, 0];
		case "multibrowse":
			return [
				0,
				56,
				carouselWidth / 2 + 24,
				carouselWidth,
				carouselWidth / 2 + 24,
				56,
				0,
			];
		default:
			return [0, 56, carouselWidth, 56, 0];
	}
};
export const getLeftOutputRange = (
	mode: "hero" | "multibrowse" | "uncontained",
	carouselWidth: number,
) => {
	switch (mode) {
		case "hero":
			return [0, 0, 0, 0, 0];
		case "multibrowse":
			return [0, -carouselWidth / 2 + 16, 4, 0, 0, 0, 0];
		default:
			return [0, 56, carouselWidth, 56, 0];
	}
};
